<template>
  <validation-observer
    ref="form"
    #default="{ invalid }"
  >
    <b-modal
      :id="modalName"
      size="lg"
      ok-only
      :ok-title="$t('save')"
      :ok-disabled="submitSpinner || invalid"
      no-close-on-backdrop
      @ok="onSubmit"
      @hidden="hideModal"
    >
      <template #modal-title="{}">
        <span>
          {{ isUpdated ? $t("Update") : $t("Create") }}
        </span>
        <span v-if="isUpdated">{{ form.name }}</span>
      </template>
      <b-form>
        <b-row>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Name')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Name')"
                vid="name"
                rules="required"
              >
                <b-form-input
                  id="name"
                  v-model="form.name"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Name')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Value')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Value')"
                vid="value"
                rules="required"
              >
                <b-form-input
                  id="value"
                  v-model="form.value"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Value')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Price')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Price')"
                vid="price"
                rules="required"
              >
                <b-form-input
                  id="price"
                  v-model="form.price"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Price')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Discount')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Discount')"
                vid="discount"
                rules="required"
              >
                <b-form-input
                  id="discount"
                  v-model="form.discount"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Discount')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Type')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Type')"
                vid="type"
                rules="required"
              >
                <v-select
                  v-model="form.type"
                  :options="additionalData.types"
                  :clearable="false"
                  :reduce="_type => _type.key.toString()"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Unit')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Unit')"
                vid="unit"
                rules="required"
              >
                <v-select
                  v-model="form.unit"
                  :options="additionalData.units"
                  :clearable="false"
                  :reduce="_unit => _unit.key.toString()"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

      </b-form>
      <template #modal-ok="{}">
        <span>
          <b-spinner
            v-if="submitSpinner"
            small
          />
          {{ $t("save") }}
        </span>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import { EditFormLayoutMixin, EditModalMixin } from '../../../../common/mixins/form'

export default {
  name: 'ProductsEditModal',
  components: {

  },
  mixins: [EditFormLayoutMixin, EditModalMixin],
  data() {
    return {
      routeName: 'products',
      modalName: 'modal-products-edit',
      useRouteName: true,
      createAbleFields: [
        'name',
        'price',
        'discount',
        'value',
        'unit',
        'type',
      ],
    }
  },
}
</script>

<style scoped>

</style>
